
import {useRef, useState} from 'react';
import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
// import CircularProgress from '@mui/material/CircularProgress';
// // import Alert from '@mui/material/Alert';

import { useTranslation } from 'react-i18next';

import { 
    WhiteSpace,
    Button,
    TextLinear,
    TextMax,
    TextM,
    TextS,
    Hr,
    Card,
    FlexBLock,
    Dialog,
    Tips,
    Input
} from '../../components';

import {IconImg} from '../../components/Icon'
import { useBalance } from '../../context/balance'
import { useStakeStairCvc, useClaimInitialIdentities, useMerchantStakeData, useClaimMaturedCvc, useMerchantData, useMerchantFeeData, useWithdrawUsd2, useBuyMerchantIdentity, useDepositUsd, useGetUsd, useMerchantSwapData, useRedeemUsd2 } from '../../hook/merchant/useMerchant'

import {
    EtherToInt,
} from '../../ethers/e'

function Metchant () {
    const {t} = useTranslation()
    return (
        <Container>
            <FlexBLock style={{ gap: 8, flexWrap: 'wrap' }}>
                <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./stock-market.png'/> {t("Merchant")}</TextMax>
                <MerchantCVCStakes />
            </FlexBLock>
            <WhiteSpace/>
            <MetchantBuyer />
            <WhiteSpace/>
            <MetchantUSDSwap />
            <WhiteSpace/>
            <MetchantUSD2Swap />
        </Container>
    )
}

export default Metchant

export function MetchantUSD2Swap () {
    const {t} = useTranslation()
    const { balances } = useBalance()
    const swap = useMerchantSwapData()
    const action = useRedeemUsd2()
    const quota = swap.hasData && !swap.error ? swap.data.withdrawalQuota : null
    const quote = action.quote || action.displayQuote
    const error = action.error || action.quoteError?.message || swap.error?.message
    const lastError = useRef(null)
    if (error) lastError.current = error
    return (
        <Card>
            <TextM block>{t("USD2 Swap to USDT")}</TextM>
            <TextS block style={{ marginBottom: '4px' }}>
                {t('Balance')} <TextLinear>{balances?.USD2 == null ? '--' : EtherToInt(balances.USD2)}</TextLinear> USD2 · <TextLinear linear='2'>{balances?.CVC == null ? '--' : EtherToInt(balances.CVC)}</TextLinear> CVC
            </TextS>
            <Input
                input={{ ...action.amountInput, type: 'text', placeholder: '0.00', inputProps: { inputMode: 'decimal', 'aria-label': t('USD2 amount') } }}
                after={<Button size='small' type='d' disabled={action.button.loading || balances?.USD2 == null} onClick={() => action.amountInput.onChange(String(balances.USD2))}>{t('Max')}</Button>}
            />

            <WhiteSpace />
            <FlexBLock style={{ marginBottom: '4px', gap: 8 }}>
                <TextS color='2'>{t("Free Quota Left (24h)")}</TextS>
                <TextS aria-label={t("Free quota remaining")} style={{ whiteSpace: 'nowrap' }}>{quota ? EtherToInt(quota.freeAvailable) : '--'} <TextS color='2'>/ 100 U</TextS></TextS>
            </FlexBLock>
            <FlexBLock style={{ gap: 8 }}>
                <TextS color='2'>{t("Total Quota Left (24h)")}</TextS>
                <TextS aria-label={t("Total quota remaining")} style={{ whiteSpace: 'nowrap' }}>{quota ? EtherToInt(quota.totalAvailable) : '--'} <TextS color='2'>/ 10,000 U</TextS></TextS>
            </FlexBLock>
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <FlexBLock style={{ gap: 8 }}>
                <TextS color='2'>{t("Required CVC Stake")}</TextS>
                <TextS style={{ whiteSpace: 'nowrap' }}><TextLinear>{quote ? EtherToInt(quote.cvcRequired) : '--'}</TextLinear> CVC</TextS>
            </FlexBLock>
            <TextS block color='2' style={{ marginTop: '4px' }}>{t("First 100 U: no CVC required. Beyond the free quota: 10% CVC stake.")} </TextS>
            <WhiteSpace />
            <Button {...action.button} type='b' style={{ width: '100%' }}>{action.button.loading ? action.button.children : t('Swap')}</Button>
            {lastError.current && <TextS
                block color='2' role={error ? 'alert' : undefined} aria-hidden={!error}
                style={{ marginTop: 6, visibility: error ? 'visible' : 'hidden' }}
            >
                {t(error || lastError.current)}
            </TextS>}
        </Card>
    )
}

export function MetchantUSDSwap () {
    const {t} = useTranslation()
    const { balances } = useBalance()
    const action = useGetUsd()
    const mixedQuote = action.mixed.quote || action.mixed.displayQuote
    const singleQuote = action.single.quote || action.single.displayQuote
    const merchant = useMerchantData()
    const multiplier = !merchant.error && merchant.data.identities.merchant.active ? 5 : 1
    const error = action.single.error || action.mixed.error || action.single.quoteError?.message || action.mixed.quoteError?.message
    const previousError = useRef(null)
    // Preserve the message slot after a failure so recovery does not shift the card.
    if (error) previousError.current = error
    const displayedError = error || previousError.current
    return (
        <Card>
            <FlexBLock justify='flex-start' align='baseline' style={{ gap: 6 }}>
                <TextM style={{ lineHeight: '20px' }}>{t("Get USD")}</TextM>
                <Tips type={multiplier === 5 ? 'a' : 'd'} style={{ lineHeight: 1, ...(multiplier === 1 ? { background: 'linear-gradient(15deg, rgb(123 126 147), rgb(37 65 65))' } : {}) }}>X{multiplier}</Tips>
            </FlexBLock>
            <TextS block style={{ marginBottom: '4px' }}>
                {t('Balance')} <TextLinear>{balances?.USDT === undefined ? '--' : EtherToInt(balances.USDT)}</TextLinear> USDT · <TextLinear linear='2'>{balances?.CVCD === undefined ? '--' : EtherToInt(balances.CVCD)}</TextLinear> CVCD
            </TextS>
            <Input
                input={{ ...action.amountInput, type: 'text', placeholder: '0.00', inputProps: { inputMode: 'decimal', 'aria-label': t('USDT amount') } }}
                after={<Button size='small' type='d' disabled={action.loading || balances?.USDT == null} onClick={() => action.amountInput.onChange(String(balances.USDT))}>{t('Max')}</Button>}
            />

            {!action.sponsorBound && <>
                <WhiteSpace />
                <TextS as='label' htmlFor='get-usd-referrer' block>{t("Referrer Address")}</TextS>
                <Input input={{ ...action.sponsorInput, id: 'get-usd-referrer', placeholder: '0x...', required: true, autoComplete: 'off', inputProps: { spellCheck: false } }} />
            </>}
            <WhiteSpace />
            <TextS block color='2' aria-label={t("CVCD + USDT quote")}>
                <span style={{ color: '#fff' }}>{action.requiredUsdt == null ? '--' : EtherToInt(action.requiredUsdt)}</span> USDT + <span style={{ color: '#fff' }}>{mixedQuote ? EtherToInt(mixedQuote.cvcdUsed) : '--'}</span> CVCD = <span style={{ color: '#fff' }}>{mixedQuote ? EtherToInt(mixedQuote.usdReceived) : '--'}</span> USD
            </TextS>
            <TextS block color='2' aria-label={t("USDT quote")}>
                <span style={{ color: '#fff' }}>{action.requiredUsdt == null ? '--' : EtherToInt(action.requiredUsdt)}</span> USDT = <span style={{ color: '#fff' }}>{singleQuote ? EtherToInt(singleQuote.usdReceived) : '--'}</span> USD
            </TextS>
            <WhiteSpace />
            <FlexBLock>
                <GetUsdButton {...action.single.button} type='b'><span>{action.single.button.loading ? action.single.button.children : 'USDT'}</span></GetUsdButton>
                <GetUsdButton {...action.mixed.button} type='d'><span>{action.mixed.button.loading ? action.mixed.button.children : 'CVCD + USDT'}</span></GetUsdButton>
            </FlexBLock>
            {action.receivedUsd != null && <TextS block role='status' style={{ marginTop: 6 }}>
                {t('Received {{amount}} USD', { amount: action.receivedUsd })}
            </TextS>}
            {displayedError && <TextS block color='2' role={error ? 'alert' : undefined} aria-hidden={!error} style={{ marginTop: 6, visibility: error ? 'visible' : 'hidden' }}>{t(displayedError)}</TextS>}
        </Card>
    )
}

// Keep transaction-stage labels and the spinner within the idle button dimensions.
const GetUsdButton = styled(Button)`
    width: 49%;
    min-width: 0;
    height: 33px;
    white-space: nowrap;
    > span:not(.MuiButton-startIcon):not(.MuiTouchRipple-root) {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .MuiButton-startIcon { flex-shrink: 0; }
`

function MetchantStake ({ principal }) {
    const {t} = useTranslation()
    const { balances } = useBalance()
    const [open, setOpen] = useState(false)
    const action = useDepositUsd(() => setOpen(false))
    return (
        <>
            <FlexBLock>
                <TextS block>{t("Balance")} <TextLinear>{balances?.USD === undefined ? '--' : EtherToInt(balances.USD)}</TextLinear> USD</TextS>
                <TextS color='2'>{t("Total Deposited")} <TextS>{principal == null ? '--' : EtherToInt(principal)}</TextS> USD</TextS>
            </FlexBLock>
            <WhiteSpace />
            <Button type='b' style={{ width: '100%' }} aria-haspopup='dialog' onClick={() => setOpen(true)}>{t("Stake")}</Button>
            <Dialog value={open} onChange={setOpen}>
                <Card style={{ width: 360, maxWidth: '100%', boxSizing: 'border-box' }}>
                    <FlexBLock style={{ gap: 8 }}>
                        <TextM>{t("Stake USD")}</TextM>
                        <Button type='e' size='small' onClick={() => setOpen(false)}>{t("Close")}</Button>
                    </FlexBLock>
                    <WhiteSpace />
                    <FlexBLock style={{ gap: 8 }}>
                        <TextS as='label' htmlFor='merchant-usd-amount'>{t("Amount")}</TextS>
                        <TextS>{t("Balance")} <TextLinear>{balances?.USD === undefined ? '--' : EtherToInt(balances.USD)}</TextLinear> USD</TextS>
                    </FlexBLock>
                    <Input
                        after={<Button size='small' type='d' disabled={action.button.loading || action.amountInput.readOnly || balances?.USD == null} onClick={() => action.amountInput.onChange(String(balances.USD))}>{t("Max")}</Button>}
                        input={{ ...action.amountInput, id: 'merchant-usd-amount', placeholder: '0.00', type: 'number', required: true, inputProps: { min: 0, inputMode: 'decimal' } }}
                    />
                    <WhiteSpace />
                    {!action.sponsorBound && <>
                        <TextS as='label' htmlFor='merchant-referrer' block>{t("Referrer Address")}</TextS>
                        <Input input={{ ...action.sponsorInput, id: 'merchant-referrer', placeholder: '0x...', required: true, autoComplete: 'off', inputProps: { spellCheck: false } }} />
                    </>}
                    <WhiteSpace />
                    <Hr />
                    <WhiteSpace />
                    <FlexBLock style={{ gap: 8 }}>
                        <TextS color='2'>{t("Pending Release (1:1)")}</TextS>
                        <TextS>{action.amountInput.value || '--'} USD2</TextS>
                    </FlexBLock>
                    <TextS block color='2' style={{ marginTop: 4 }}>{t("0.05% of the remaining USD2 balance is released daily.")}</TextS>
                    <TextS block color='2' style={{ marginTop: 4 }}>{t('USD deposits add your own release rights only; they do not generate referral rewards or increase reward limits.')}</TextS>
                    <WhiteSpace />
                    <Button {...action.button} type='b' style={{ width: '100%' }}>{action.button.loading ? action.button.children : t('Confirm Stake')}</Button>
                </Card>
            </Dialog>
        </>
    )
}

export function MerchantCVCStakes() {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)
    const { data, loading, error, refresh, hasData } = useMerchantStakeData()
    const claim = useClaimMaturedCvc()
    const available = hasData && !error
    const orders = available ? data.orders : []
    const sources = { swap: 'Swap', swapFee: 'Swap Fee Rewards', manager: 'Manager' }
    const remaining = seconds => {
        const days = Math.floor(seconds / 86400)
        const hours = Math.floor(seconds % 86400 / 3600)
        const minutes = Math.floor(seconds % 3600 / 60)
        return t('{{days}}d {{hours}}h {{minutes}}m {{seconds}}s', { days, hours, minutes, seconds: seconds % 60 })
    }

    return (
        <>
            <CVCStakeSummary type='button' aria-haspopup='dialog' aria-label={t("View total CVC staked and stake orders")} onClick={() => setOpen(true)}>
                <TextS block color='2'>{t("Total CVC Staked")}</TextS>
                <TextS><TextLinear>{available ? data.totalStaked : '--'}</TextLinear> CVC ›</TextS>
            </CVCStakeSummary>
            <Dialog value={open} onChange={setOpen}>
                <CVCStakeCard>
                    <FlexBLock style={{ gap: 8 }}>
                        <TextM>{t("My CVC Stakes")}</TextM>
                        <Button type='e' size='small' onClick={() => setOpen(false)}>{t("Close")}</Button>
                    </FlexBLock>
                    <WhiteSpace />
                    <FlexBLock style={{ gap: 8 }}>
                        <TextS color='2'>{t("Total Staked")}</TextS>
                        <TextS>{available ? data.totalStaked : '--'} CVC</TextS>
                    </FlexBLock>
                    <WhiteSpace />
                    <FlexBLock style={{ gap: 8 }}>
                        <div>
                            <TextS block>{t("Unlocked CVC")}</TextS>
                            <TextLinear style={{ fontSize: 24 }}>{available ? data.totalClaimable : '--'}</TextLinear> <TextS color='2'>/ CVC</TextS>
                        </div>
                        <Button {...claim} type='a' size='small' disabled={claim.disabled || !available || !orders.some(order => order.claimable)} />
                    </FlexBLock>
                    <WhiteSpace />
                    <Hr />
                    <WhiteSpace />
                    <FlexBLock style={{ gap: 8 }}>
                        <TextM>{t("Stake Orders")}</TextM>
                        <TextS color='2'>{available ? orders.length : loading ? t('Loading…') : '--'}</TextS>
                    </FlexBLock>
                    <CVCOrderList role="region" aria-label={t("Stake orders")} tabIndex={0}>
                    {orders.map((order, index) => (
                        <div key={order.key} style={{ marginTop: 12 }}>
                            <FlexBLock style={{ gap: 8 }}>
                                <TextS>#{index + 1} · {t(sources[order.source])}</TextS>
                                <TextS style={{ whiteSpace: 'nowrap' }}>{order.amount} CVC</TextS>
                            </FlexBLock>
                            <FlexBLock style={{ gap: 8, marginTop: 4, flexWrap: 'wrap' }}>
                                <TextS color='2'>{order.source !== 'manager' && `${t('7 weeks')} · `}{t("Release at maturity")}</TextS>
                                <TextS color='2'><TextS style={{ fontVariantNumeric: 'tabular-nums' }}>{order.withdrawn ? t('Claimed') : remaining(order.remainingSeconds)}</TextS></TextS>
                            </FlexBLock>
                            <WhiteSpace />
                            <Hr />
                        </div>
                    ))}
                    <WhiteSpace />
                    {loading && !hasData && <TextS block color='2' role='status'>{t("Loading…")}</TextS>}
                    {error && <div role='alert'>
                        <TextS block color='2'>{t(error.message)}</TextS>
                        <Button size='small' onClick={refresh}>{t("Retry")}</Button>
                    </div>}
                    {available && !orders.length && <TextS block color='2'>{t("No stake orders.")}</TextS>}
                    </CVCOrderList>
                </CVCStakeCard>
            </Dialog>
        </>
    )
}

const CVCStakeCard = styled(Card)`
    width: 380px;
    max-width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 64px);
    max-height: calc(100dvh - 64px);
    min-height: 0;
    & > * { flex-shrink: 0; }
`
const CVCOrderList = styled('div')`
    min-height: 0;
    flex: 1 1 auto;
    && { flex-shrink: 1; }
    overflow-y: auto;
    overscroll-behavior-y: contain;
    -webkit-overflow-scrolling: touch;
`

const CVCStakeSummary = styled('button')`
    padding: 4px 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: right;
    cursor: pointer;
    margin-left: auto;
    &:hover { opacity: .8; }
    &:focus-visible { outline: 1px solid currentColor; outline-offset: 3px; }
`


// Format the position directly from decimal strings to avoid floating-point rounding.
function formatPositionAmount(value) {
    if (value == null) return '--'
    const [integer, fraction = ''] = String(value).split('.')
    const decimals = fraction.slice(0, 6).replace(/0+$/, '')
    return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (decimals ? `.${decimals}` : '')
}

// Keep amounts within their column while the shared Button uses its default sizing.
const Usd2ClaimRow = styled('div')`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 12px;
`
export function MetchantBuyer () {
    const {t} = useTranslation()
    const merchant = useMerchantData()

    console.log(
        merchant, " merchant"
    )

    const claim = useWithdrawUsd2(undefined, merchant)
    const initial = useClaimInitialIdentities()
    const available = !merchant.error && merchant.data.blockTimestamp > 0
    return (
        <Card type='j'>
            <Usd2ClaimRow>
                <div style={{ minWidth: 0 }}>
                    <TextM block>{t("Claimable")}</TextM>
                    <div title={available ? `${merchant.data.position.availableAmount} USD2` : undefined} style={{ height: 36, lineHeight: '36px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontVariantNumeric: 'tabular-nums' }}>
                        <TextLinear style={{fontSize: '24px'}}>{available ? formatPositionAmount(merchant.data.position.availableAmount) : '--'}</TextLinear> <TextM color='2'> / USD2</TextM>
                    </div>
                    <TextS block color='2' title={available ? `${merchant.data.position.lockedAmount} USD2` : undefined} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontVariantNumeric: 'tabular-nums' }}>{t("Releaseable")} <TextS>{available ? formatPositionAmount(merchant.data.position.lockedAmount) : '--'}</TextS> USD2</TextS>
                </div>
                <Button {...claim} type="a" size='small' disabled={claim.disabled || !available}>{claim.loading ? claim.children : t('Claim')}</Button>
            </Usd2ClaimRow>
            {/* <TextS block color='2' role={merchant.refreshError ? 'status' : undefined}
                aria-hidden={!merchant.refreshError}
                style={{ minHeight: '2.5em', marginTop: 6, visibility: merchant.refreshError ? 'visible' : 'hidden' }}>
                {t('Refresh delayed. Showing last loaded data.')}
            </TextS> */}
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <MerchantStairMigration />
            <MerchantIdentities data={available ? merchant.data : null} />
            {initial.available && <FlexBLock style={{ gap: 8, marginTop: 12 }}>
                <TextS color='2'>{t('Node benefit: activate {{identities}} free for 100 days.', {
                    identities: [initial.memberAvailable && t('Member'), initial.vipAvailable && t('VIP')].filter(Boolean).join(' / ')
                })}</TextS>
                <Button {...initial.button} type='a' size='small' style={{ flexShrink: 0 }} />
            </FlexBLock>}
            
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <MetchantRewards data={available ? merchant.data : null} />
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <MetchantStake principal={available ? merchant.data.principal : null} />
        </Card>
    )
}

export function MerchantStairMigration() {
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const action = useStakeStairCvc(() => setOpen(false))
    const { summary } = action
    
    if (!action.available && !open && !summary.error) return null
    return <>
        {summary.error ? <FlexBLock role='alert' style={{ gap: 8, flexWrap: 'nowrap', alignItems: 'center' }}>
            <TextS color='2'>{t(summary.error.message)}</TextS>
            <Button size='small' style={{ flexShrink: 0 }} onClick={summary.refresh}>{t('Retry')}</Button>
        </FlexBLock> : action.available && <FlexBLock style={{ gap: 8 }}>
            <TextS color='2'>
                {summary.data.isLegacy ? <>
                    {t('Refundable')} <TextS>{formatPositionAmount(summary.data.cvcRefund)} CVC · {formatPositionAmount(summary.data.netProfit)} CVCD</TextS>
                </> : <>{t('Stair')} <TextS>{formatPositionAmount(summary.data.remainingPrincipal)}</TextS></>}
            </TextS>
            <Button type='a' size='small' style={{ flexShrink: 0 }} onClick={() => setOpen(true)}>{t(summary.data.isLegacy ? 'Settle Legacy Stair' : 'One-click Migration')}</Button>
        </FlexBLock>}
        <WhiteSpace />
        <Dialog value={open} onChange={value => { if (!action.button.loading) setOpen(value) }}>
            <Card style={{ width: 360, maxWidth: '100%', boxSizing: 'border-box' }}>
                <FlexBLock style={{ gap: 8 }}>
                    <TextM>{t('Stair Migration')}</TextM>
                    <Button type='e' size='small' disabled={action.button.loading} onClick={() => setOpen(false)}>{t('Close')}</Button>
                </FlexBLock>
                <WhiteSpace />
                <TextS block>{t(summary.data.isLegacy ? 'Settle migrated principal without adding USD2 again, receive remaining profits and recover the CVC staked for Stair migration.' : 'Migrate all active principal into equal USD2 rights. No CVC stake or token approval is required.')}</TextS>
                <WhiteSpace />
                <TextS block color='2'>{t('Order profits are paid in CVCD after a 1% fee per order. The original 7-day condition applies. Each account can migrate once; remaining principal after a partial legacy migration cannot migrate again.')}
                </TextS>
                <TextS block>{t('Estimated Net Profit')}: {formatPositionAmount(summary.data.netProfit)} CVCD</TextS>
                <TextS block>{t('CVC Refund')}: {formatPositionAmount(summary.data.cvcRefund)} CVC</TextS>
                <WhiteSpace />
                <Button {...action.button} type='b' style={{ width: '100%' }} />
                {action.error && <TextS block color='2' role='alert'>{t(action.error)}</TextS>}
            </Card>
        </Dialog>
    </>
}

function MetchantRewards({ data }) {
    const {t} = useTranslation()
    // 推广分项来自 getReferralRewardBreakdown；合约已计算身份倍率，展示不再次翻倍。
    const fees = useMerchantFeeData()
    const feeData = fees.hasData && !fees.error ? fees.data : null
    const multiplier = data?.identities?.bole?.active ? 2 : 1
    const rewards = [
        { label: 'My Direct Rewards', amount: data?.rewards?.direct?.totalAmount ?? null, multiplier },
        { label: 'My Indirect Rewards', amount: data?.rewards?.indirect?.totalAmount ?? null, multiplier },
        { label: 'My Team Rewards', amount: data?.rewards?.team?.totalAmount ?? null },
        { label: 'Zero Address Fee', amount: feeData?.zeroLine ?? null, token: 'USDT', hideWhenEmpty: true },
        { label: 'Team Fee', amount: feeData?.community ?? null, token: 'USDT', hideWhenEmpty: true },
    ]

    return (
        <>
            <FlexBLock role='group' aria-label={t('Total USDT Exchanged')} style={{ gap: 8, marginBottom: 2 }}>
                <TextS color='2'>{t('Total USDT Exchanged')}</TextS>
                <TextS style={{ whiteSpace: 'nowrap' }}>{formatPositionAmount(data?.usdtPrincipal)} <TextS color='2'>USDT</TextS></TextS>
            </FlexBLock>
            {rewards.filter(reward => !reward.hideWhenEmpty || Number(reward.amount) > 0).map(({ label, amount, multiplier, token = 'USD2' }) => (
                <FlexBLock key={label} role="group" aria-label={t(label)} style={{ marginBottom: '2px', gap: 8 }}>
                    <FlexBLock style={{ gap: 6, flexWrap: 'wrap' }}>
                        <TextS color='2'>{t(label)}{multiplier && <> <Tips type={multiplier === 2 ? 'a' : 'd'} style={multiplier === 1 ? { background: 'linear-gradient(15deg, rgb(123 126 147), rgb(37 65 65))' } : undefined}>X{multiplier}</Tips></>}</TextS>
                    </FlexBLock>
                    <TextS style={{ whiteSpace: 'nowrap' }}>
                        {amount === null ? '--' : EtherToInt(amount)} <TextS color='2'>{token}</TextS>
                    </TextS>
                </FlexBLock>
            ))}
        </>
    )
}

// 身份价格与展示文案保持不变，状态及剩余天数使用同一区块的链上数据。
const merchantIdentities = [
    { id: 1, name: 'Member', key: 'member', price: 1, benefit: 'Rewards{{multiplier}}', detail: 'Earn referral rewards: 50% direct, 25% indirect, plus team rewards by level.' },
    { id: 2, name: 'VIP', key: 'bole', price: 1, benefit: 'Rewards{{multiplier}}', detail: 'Double direct and indirect referral rewards: 100% direct and 50% indirect.' },
    { id: 3, name: 'Merchant', key: 'merchant', price: 5, benefit: 'USD2 × 5', detail: 'USD2 ×5 membership benefit. Exchange rules will be confirmed before contract integration.' },
]

function MerchantIdentities({ data }) {
    const {t} = useTranslation()
    const [selectedKey, setSelectedKey] = useState(null)
    const identities = merchantIdentities.map(identity => {
        const status = data?.identities?.[identity.key]
        return {
            ...identity,
            active: status?.active ?? null,
            remainingDays: status?.active
                ? Math.max(0, Math.ceil((status.expiresAt - data.blockTimestamp) / 86400))
                : 0
        }
    })
    const selectedIdentity = identities.find(identity => identity.key === selectedKey)
    const action = useBuyMerchantIdentity(selectedIdentity?.id, () => setSelectedKey(null))
    const setSelectedIdentity = identity => setSelectedKey(identity?.key ?? null)
    return (
        <>
        <IdentityGrid aria-label={t("Membership perks")}>
            {identities.map(identity => (
                <IdentityTile key={identity.name}>
                    <TextS block>{t(identity.name)}</TextS>
                    <TextS block color='2'>{t(identity.benefit, { multiplier: identity.key === 'bole' ? ' × 2' : '' })}</TextS>
                    <TextS block color='2'>
                        {identity.active === null ? '--' : identity.active ? <><span style={{ color: '#fff' }}>{identity.remainingDays}</span> {t("Days")}</> : t('Not Active')}
                    </TextS>
                    <Button
                        type={identity.active ? 'b' : 'a'}
                        size='small'
                        onClick={() => setSelectedIdentity(identity)}
                        disabled={identity.active === null || action.button.loading}
                        aria-label={`${t(identity.name)}: ${t(identity.active ? 'extend membership' : 'activate membership')}`}
                    >
                        {identity.active ? t('Extend +') : t('Activate')}
                    </Button>
                </IdentityTile>
            ))}
        </IdentityGrid>
        <Dialog value={Boolean(selectedIdentity)} onChange={open => !open && setSelectedIdentity(null)}>
            {selectedIdentity && (
                <Card style={{ width: 360, maxWidth: '100%', boxSizing: 'border-box' }}>
                    <FlexBLock style={{ gap: 8, alignItems: 'flex-start' }}>
                        <TextM block>{t(selectedIdentity.name)} · {selectedIdentity.active ? t('Extend Membership') : t('Activate Membership')}</TextM>
                        <Button size='small' type='e' style={{ flexShrink: 0 }} onClick={() => setSelectedIdentity(null)}>{t("Close")}</Button>
                    </FlexBLock>
                    <WhiteSpace />
                    <TextS block>{t(selectedIdentity.detail)}</TextS>
                    <WhiteSpace />
                    {selectedIdentity.active && (
                        <TextS block color='2'>{t('{{days}} days left. You can extend before expiry.', { days: selectedIdentity.remainingDays })}</TextS>
                    )}
                    <TextS block>{t('{{price}} U / 100 days', { price: selectedIdentity.price })}</TextS>
                    <WhiteSpace />
                    <Hr />
                    <WhiteSpace />
                    {!action.sponsorBound && <>
                        <TextS as='label' htmlFor='membership-referrer' block>{t("Referrer Address")}</TextS>
                        <Input input={{ ...action.sponsorInput, id: 'membership-referrer', placeholder: '0x...', required: true, autoComplete: 'off', inputProps: { spellCheck: false } }} />
                    </>}
                    <WhiteSpace />
                    <Button {...action.button} type='b' style={{ width: '100%' }}>
                        {action.button.loading ? action.button.children : selectedIdentity.active ? t('Confirm Extension') : t('Confirm Activation')}
                    </Button>
                </Card>
            )}
        </Dialog>
        </>
    )
}

const IdentityGrid = styled('div')`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
`

const IdentityTile = styled(Card)`
    display: grid;
    grid-template-rows: auto 1fr auto auto auto;
    align-items: center;
    gap: 4px;
    min-width: 0;
    text-align: center;
`
